import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { ProgramStatus } from '../../../../../api/types/programs/program-status';
import { ProgramWithStudentStatus } from '../types';
import { ProgramStudentStatus } from '../../../../../api/types/programs/students/program-student-status';
import { updateStudentStatusInProgramOperation } from './operations/update-student-status-in-program-operation';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';

interface StatusDialogProps {
  visible: boolean;
  onHide: () => void;
  selectedProgram: ProgramWithStudentStatus | null;
  user: UserSummaryType;
  newStatus: ProgramStudentStatus;
  setNewStatus: (status: ProgramStudentStatus) => void;
  statusDate: Date | null;
  setStatusDate: (date: Date | null) => void;
  setSelectedStatus: (status: 'program' | 'student') => void;
}

export const StatusDialog: React.FC<StatusDialogProps> = ({
  visible,
  onHide,
  selectedProgram,
  user,
  newStatus,
  setNewStatus,
  statusDate,
  setStatusDate,
  setSelectedStatus,
}) => {
  const [loading, setLoading] = useState(false);

  if (!selectedProgram) return null;

  const programStatusOptions = [
    {
      label: ProgramStatus[ProgramStatus.ACTIVE],
      value: ProgramStatus.ACTIVE,
    },
    {
      label: ProgramStatus[ProgramStatus.INIT],
      value: ProgramStatus.INIT,
    },
    {
      label: ProgramStatus[ProgramStatus.FINISHED],
      value: ProgramStatus.FINISHED,
    },
    {
      label: ProgramStatus[ProgramStatus.CLOSE],
      value: ProgramStatus.CLOSE,
    },
  ];

  const studentStatusOptions = [
    {
      label: 'נרשם',
      value: ProgramStudentStatus.REGISTERED,
    },
    {
      label: 'לומד',
      value: ProgramStudentStatus.STUDYING,
    },
    {
      label: 'ביטל',
      value: ProgramStudentStatus.CANCELLED,
    },
    {
      label: 'עזב',
      value: ProgramStudentStatus.LEFT,
    },
    {
      label: 'סיים',
      value: ProgramStudentStatus.COMPLETED,
    },
    {
      label: 'דופלם',
      value: ProgramStudentStatus.GRADUATED,
    },
  ];

  const updateProgramStatus = async () => {
    await updateStudentStatusInProgramOperation(
      selectedProgram.branchId,
      selectedProgram.id,
      user.id,
      newStatus,
      statusDate,
      setLoading,
      onHide,
    );
  };

  return (
    <Dialog
      header={'עדכון סטטוס סטודנט'}
      visible={visible}
      style={{ width: '450px' }}
      modal
      onHide={onHide}
      footer={
        <div>
          <Button
            label="ביטול"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text"
          />
          <Button
            label="עדכון"
            icon="pi pi-check"
            onClick={updateProgramStatus}
            disabled={!newStatus || !statusDate}
            autoFocus
            loading={loading}
          />
        </div>
      }
    >
      <div className="status-dialog-content">
        <div className="field">
          <label htmlFor="status">סטטוס</label>
          <Dropdown
            id="status"
            value={newStatus}
            options={studentStatusOptions}
            style={{ height: '36px', width: '100%', alignItems: 'center' }}
            onChange={(e) => setNewStatus(e.value)}
            placeholder="בחר סטטוס"
            className="w-full"
          />
        </div>
        {
          <div className="field">
            <label htmlFor="statusDate">
              {newStatus === ProgramStudentStatus.REGISTERED
                ? 'תאריך רישום'
                : newStatus === ProgramStudentStatus.CANCELLED
                  ? 'תאריך ביטול'
                  : newStatus === ProgramStudentStatus.LEFT
                    ? 'תאריך עזיבה'
                    : newStatus === ProgramStudentStatus.COMPLETED
                      ? 'תאריך סיום'
                      : newStatus === ProgramStudentStatus.STUDYING
                        ? 'תאריך התחלת לימודים'
                        : ''}
            </label>
            <Calendar
              id="statusDate"
              value={statusDate}
              onChange={(e) => setStatusDate(e.value as Date)}
              style={{
                height: '36px',
                width: '100%',
                direction: 'ltr',
              }}
              inputStyle={{ direction: 'rtl', textAlign: 'right' }}
              showIcon
              dateFormat="dd/mm/yy"
              className="w-full"
            />
          </div>
        }
      </div>
    </Dialog>
  );
};
